/**
 * Shared Product · GI Presenze — NotificationBell wrapper
 *
 * Wrapper Product-specific attorno al `NotificationBell` Foundation/Core.
 * Il CORE gestisce rendering, polling, mark-read, delete, DetailDialog.
 * Questo wrapper inietta la conoscenza di dominio GI Presenze:
 * - `resolveNotificationMeta`: dispatcher builders (getNotificationMeta)
 * - `tabs`: NOTIFICATION_TABS (Non lette, Recenti)
 * - `onNotify`: fire desktop notification con category-gating GI Presenze
 * - `isEnabled`: RBAC guard per i ruoli abilitati alle notifiche
 *
 * Ogni Product Pack diverso creera' un proprio wrapper analogo.
 */
import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useEffectiveRole } from "@/foundation/context";
import { NotificationBell as SuiteNotificationBell } from "@/foundation/notifications";
import { getNotificationMeta, NOTIFICATION_TABS } from "@/lib/notifications";
import { fireDesktopNotification } from "@/lib/desktopNotifications";

const ROLES_ENABLED = ["admin", "client", "responsabile", "employee"];

export default function NotificationBellPresenze() {
  const { user } = useAuth();
  const effectiveRole = useEffectiveRole();
  const isEnabled = !!user && ROLES_ENABLED.includes(effectiveRole);

  const handleNotify = (n, meta, ctx) => {
    fireDesktopNotification({
      title: meta?.title,
      body: meta?.body,
      tag: `notif-${n.id}`,
      kind: n.kind,
      onClick: () => ctx?.openDetail?.(),
    });
  };

  return (
    <SuiteNotificationBell
      resolveNotificationMeta={getNotificationMeta}
      tabs={NOTIFICATION_TABS}
      onNotify={handleNotify}
      isEnabled={isEnabled}
    />
  );
}
